module.exports = __webpack_public_path__ + "img/rightcloud.bd9c506b.svg";